import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';

type SentryConfig = {
  enabled: boolean,
  dsn: string
  environment: 'development' | 'staging' | 'production',
  integrations: string[],
  tracesSampleRate: number,
};

let sentryConfig: SentryConfig = {
  enabled: false,
  dsn: '',
  environment: 'development',
  integrations: ['BrowserTracing'],
  tracesSampleRate: 1,
};

try {
  sentryConfig = JSON.parse(process.env.REACT_APP_SENTRY || '');
} catch (error) {
  console.error('Environment REACT_APP_SENTRY is not configured');
}

const integrations = [];
if (sentryConfig.integrations.includes('BrowserTracing')) {
  integrations.push(new BrowserTracing());
}

Sentry.init({
  enabled: sentryConfig.enabled,
  dsn: sentryConfig.dsn,
  environment: sentryConfig.environment,
  integrations,
  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: sentryConfig.tracesSampleRate,
  initialScope: {
    tags: { app_part: 'web' },
  },
});
